<script>
import i18n from "@/i18n";
import { OAUTH_LOGIN } from "@/config/social-api";

export default {
  page() {
    return {
      title: this.$t("login.login"),
    };
  },
  data() {
    return {
      logoImg: require("@/assets/images/mainlogo_darkgree_web.png"),
      counter: 0,
    };
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  beforeDestroy() {
    document.body.classList.remove("auth-body-bg");
  },
  mounted() {
    document.body.classList.add("auth-body-bg");
    const languagecode = (navigator.language || "zh").substr(0, 2);
    i18n.locale = languagecode;
    const error = this.$route.query.error;
    if (error) this.toast(String(error));
  },
  methods: {
    startOAuth() {
      const redirect = this.$route.query.redirectFrom || "/";
      const done = `${window.location.origin}/oauth/done?redirect=${encodeURIComponent(redirect)}`;
      window.location.href = `${OAUTH_LOGIN}?next=${encodeURIComponent(done)}`;
    },
    toast(text, append = false) {
      this.counter++;
      this.$bvToast.toast(text, {
        title: this.$t("login.alter"),
        toaster: "b-toaster-top-center",
        solid: true,
        appendToast: append,
      });
    },
  },
};
</script>

<template>
  <div class="login-page login-page--centered">
    <div class="home-btn d-none d-sm-block">
      <a href="/" class="text-white">
        <i class="ri-home-4-line h4"></i>
      </a>
    </div>
    <div class="login-page__bg">
      <div class="bg-overlay"></div>
    </div>
    <div class="login-page__center d-flex align-items-center justify-content-center min-vh-100 p-4">
      <div class="login-page__card-wrap">
        <div class="login-card">
                    <div class="text-center mb-4">
                      <a href="/" class="d-inline-block">
                        <img
                          :src="logoImg"
                          alt="logo"
                          class="login-logo"
                        />
                      </a>
                      <h4 class="login-title mt-4">
                        {{ $t("login.login") }}
                      </h4>
                      <p class="login-subtitle">
                        {{ $t("login.oauthHint") }}
                      </p>
                    </div>

                    <b-alert
                      variant="danger"
                      class="mt-3"
                      v-if="notification && notification.message"
                      show
                      dismissible
                      >{{ notification.message }}</b-alert
                    >

                    <div class="p-0 mt-4">
                      <button
                        class="btn btn-primary login-btn w-100"
                        type="button"
                        @click="startOAuth"
                      >
                        {{ $t("login.oauth") }}
                      </button>
                    </div>

          <div class="mt-5 pt-4 text-center login-footer">
            <p class="mb-0">
              © 2016 Shijiazhuang MOE Information Technology Co., Ltd
            </p>
            <p class="mb-0">
              © 2015 AICO Group Limited · © 2021 AICO CLOUD UK LTD
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.login-logo {
  max-width: 180px;
  height: auto;
}
.login-btn {
  &:disabled .spinner {
    display: inline-block;
  }
}
</style>
